import React from 'react'
import { useStatsJoueursDataContext } from '../../../contexts/StatsJoueursDataContext'
import type { JoueurType, SortBy } from '../data'
import styles from './styles.module.scss'

const OPTIONS: { value: SortBy; label: string | { [x in JoueurType]: string } }[] = [
    { value: 'buts_ou_arrets', label: { joueur_de_champ: 'But', gardien: 'Arrêt' } },
    { value: 'club', label: 'Club' },
    { value: 'nom', label: 'Nom' },
]

export const SortBySelector = () => {
    const { sortBy, setSortBy, joueurType } = useStatsJoueursDataContext()

    return (
        <div>
            <select
                className={styles.select}
                value={sortBy}
                onChange={(e) => {
                    setSortBy(e.target.value as SortBy)
                }}
            >
                <option disabled>TRIER PAR :</option>
                {OPTIONS.map((x) => (
                    <option key={x.value} value={x.value}>
                        {typeof x.label === 'string' ? x.label : x.label[joueurType]}
                    </option>
                ))}
            </select>
        </div>
    )
}
